import { useCallback, useState } from 'react';
import FoundrySite from './FoundrySite';
import SmackersExperience from './SmackersExperience';

type SiteView = 'foundry' | 'smackers';

function initialView(): SiteView {
  return new URLSearchParams(window.location.search).get('experience') === 'smackers' ? 'smackers' : 'foundry';
}

export default function App() {
  const [view, setView] = useState<SiteView>(initialView);

  const showView = useCallback((next: SiteView) => {
    setView(next);
    const url = new URL(window.location.href);
    if (next === 'smackers') url.searchParams.set('experience', 'smackers');
    else url.searchParams.delete('experience');
    window.history.replaceState(null, '', url);
    window.scrollTo({ top: 0, behavior: 'auto' });
  }, []);

  if (view === 'smackers') {
    return (
      <>
        <button className="foundry-return" type="button" onClick={() => showView('foundry')}>
          <span aria-hidden="true">←</span>
          Fighter Foundry
        </button>
        <SmackersExperience />
      </>
    );
  }

  return <FoundrySite onLaunchDemo={() => showView('smackers')} />;
}
